var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('preview-cv', {
    attrs: {
      "data-to-show": _vm.isPreviewPopupDisplayed,
      "cv-to-preview": _vm.form
    },
    on: {
      "close": function ($event) {
        _vm.isPreviewPopupDisplayed = false;
      }
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm.isFormPage ? _c('action-button', {
    staticClass: "w-max my-5 lg:my-15 xl:hidden",
    attrs: {
      "border-color": "border-transparent",
      "bg-color": "bg-indigo-300",
      "bg-color-square": "bg-indigo-100",
      "icon-color": "text-indigo-600",
      "text-color": "text-gray-900",
      "icon": "expand",
      "libelle": "Aperçu"
    },
    on: {
      "clickAction": function ($event) {
        _vm.isPreviewPopupDisplayed = true;
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "xl:mt-15 grid grid-cols-11",
    class: {
      'xl:gap-x-10': _vm.isFormPage
    }
  }, [_c('div', {
    staticClass: "align-middle shadow rounded-lg border-b border-gray-200 bg-white pb-10 table min-h-halfscreen w-full",
    class: {
      'col-span-full': !_vm.isFormPage,
      'col-span-full xl:col-span-7': _vm.isFormPage
    }
  }, [_c('router-view', {
    on: {
      "downloadPDF": _vm.downloadPDF
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isFormPage,
      expression: "isFormPage"
    }],
    staticClass: "hidden col-span-4 max-h-screen xl:flex flex-col"
  }, [_c('div', {
    staticClass: "flex justify-between items-center"
  }, [_c('h4', {
    staticClass: "font-light text-gray-600 text-left"
  }, [_vm._v("Prévisualisation")]), _vm._v(" "), _c('div', {
    staticClass: "flex space-x-1.5"
  }, [_c('div', {
    staticClass: "bg-indigo-100 border-4 border-indigo-300 rounded-md p-1.5 cursor-pointer transform hover:scale-110 transition duration-300",
    attrs: {
      "id": "fullscreen"
    },
    on: {
      "click": function ($event) {
        _vm.isPreviewPopupDisplayed = true;
      }
    }
  }, [_c('icon', {
    staticClass: "w-4 h-4 text-indigo-600",
    attrs: {
      "name": "expand"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "bg-teal-100 border-4 border-teal-300 rounded-md p-1.5 cursor-pointer transform hover:scale-110 transition duration-300",
    attrs: {
      "id": "refresh-button"
    },
    on: {
      "click": _vm.refreshPage
    }
  }, [_c('icon', {
    staticClass: "w-4 h-4 text-teal-600",
    attrs: {
      "name": "refresh"
    }
  })], 1)])]), _vm._v(" "), !_vm.displayPreview ? _c('div', {
    staticClass: "flex justify-center mt-15"
  }, [_c('div', {
    staticClass: "rounded-full w-4 h-4 border-t-2 border-r-2 border-l-0 border-b-0 border-gray-900 border-opacity-25 animate-spin"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "hidden xl:inline-block transform origin-top-left mt-5 z-0 min-h-pdf",
    class: {
      'xl:scale-35 xxl:scale-40 2xl:scale-50': _vm.isPortraitOrientation,
      'xl:scale-25 xxl:scale-30 2xl:scale-40': !_vm.isPortraitOrientation
    }
  }, [_vm.displayPreview ? _c('vue-html2pdf', {
    ref: "cvPdf",
    staticClass: "bg-white w-max border-2",
    class: {
      'border-gray-600': _vm.pdfHeight <= _vm.pdfHeightMax,
      'border-pink-600': _vm.pdfHeight > _vm.pdfHeightMax
    },
    attrs: {
      "id": "containerVueHtml2PDF",
      "show-layout": false,
      "float-layout": false,
      "enable-download": true,
      "preview-modal": false,
      "manual-pagination": false,
      "paginate-elements-by-height": _vm.pdfHeightMax + 1,
      "pdf-content-width": !_vm.isPortraitOrientation ? '1122px' : '800px',
      "html-to-pdf-options": {
        enableLinks: true,
        filename: 'CV ' + _vm.username,
        jsPDF: {
          orientation: _vm.isPortraitOrientation ? 'portrait' : 'landscape',
          format: 'a4'
        },
        html2canvas: {
          scale: 2,
          useCORS: true
        }
      }
    }
  }, [_c('section', {
    attrs: {
      "slot": "pdf-content"
    },
    slot: "pdf-content"
  }, [_c('section', {
    staticClass: "pdf-item"
  }, [_c('model-pdf', {
    attrs: {
      "model-name": (((_vm.form || {}).data || {}).shaping || {}).name,
      "model-color": (((_vm.form || {}).data || {}).shaping || {}).color,
      "form": _vm.form
    }
  })], 1)])]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "-mt-136 2xl:-mt-130 2xl:mr-10",
    on: {
      "click": function ($event) {
        return _vm.SET_CURRENTSTEP(_vm.cvPages[0].name);
      }
    }
  }, [_vm.pdfHeight > _vm.pdfHeightMax ? _c('div', {
    staticClass: "flex space-x-2 items-center justify-center text-center text-base font-light text-pink-600"
  }, [_c('icon', {
    staticClass: "text-pink-600",
    attrs: {
      "name": "alert-triangle"
    }
  }), _vm._v(" "), _c('div', [_vm._v("Le contenu dépasse la taille de la page")])], 1) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "text-center text-base font-light text-indigo-600 cursor-pointer"
  }, [_vm._v("\n          Modifier le modèle\n        ")])])])])], 1);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "hidden relative xl:flex items-center bg-indigo-200 overflow-visible rounded-sm h-48 w-full"
  }, [_c('div', {
    staticClass: "px-12"
  }, [_c('p', {
    staticClass: "text-4xl text-gray-900"
  }, [_vm._v("Curriculum vitae")]), _vm._v(" "), _c('p', {
    staticClass: "mt-2 text-base font-light leading-4 2xl:leading-5 text-gray-600 max-w-2/3 2xl:max-w-11/12"
  }, [_vm._v("\n        Mettez en avant vos parcours et compétences en créant un CV\n        personnalisé à l'aide de notre outil de création.\n      ")])]), _vm._v(" "), _c('img', {
    staticClass: "hidden xl:block absolute right-5 xl:right-10 -top-8 w-60 xl:w-72",
    attrs: {
      "src": "/assets/img/Illustration-curriculum-vitae.png",
      "alt": "CV"
    }
  })]);

}]

export { render, staticRenderFns }